























































import Vue from "vue";
import education from "@/interfaces/education";
import _ from "lodash";

export default Vue.extend({
	props: ["data", "editData"],

	data() {
		return {
			newEducation: {} as education,
			arrIndex: null as number | null
		};
	},

	watch: {
		data: function () {
			this.newEducation.tyonhakijaId = this.data.tyonhakijaId;
		},
		editData: function () {
			this.arrIndex = _.indexOf(this.data.koulutukset, this.editData);
			if (this.editData) {
				this.newEducation = {...this.editData};
			}
			else {
				this.newEducation = {} as education
			}
		}
	},

	methods: {
		handleOk(bvModalEvt: any) {
			bvModalEvt.preventDefault();
			this.handleSubmit();
		},
		handleSubmit() {
			let koulutus = this.newEducation
			if (!this.editData) {
				this.data.koulutukset.push(koulutus);
			} else if (this.editData && typeof this.arrIndex == "number") {
				this.data.koulutukset[this.arrIndex] = koulutus;
			}
			this.newEducation = {} as education;
			this.newEducation.tyonhakijaId = this.data.tyonhakijaId;
			this.$nextTick(() => {
				this.$bvModal.hide("add-education");
				this.$emit("clearEditData");
			});
		},
		confirmEduDelete() {
			this.$emit("removeEducation", this.editData)
		},
		hideModal() {
			this.$bvModal.hide("add-education");
			this.$emit("clearEditData");
		},
	},
});
